import {HTMLAttributes} from "react";

import './CreditCard.scss';
import {Button, Col, Row} from "react-bootstrap";

interface CreditCardType extends HTMLAttributes<HTMLDivElement> {
	card: {
		id: number;
		bandeira: string;
		nome_titular: string;
		numero: string;
		validade: string;
	};
	lastItem: boolean;
	handleRemoveCard: (id: number) => void;
}

export function CreditCard({card, lastItem, handleRemoveCard}: CreditCardType) {
	return(
		<>
			<Row>
				<Col md={8} sm={12} xs={12}>
					<p><b>Número: </b>{card.numero}</p>
					<p><b>Nome: </b>{card.nome_titular}</p>
					<p><b>Validade: </b>{card.validade}</p>
					<p><b>Bandeira: </b>{card.bandeira}</p>
				</Col>
				<Col md={4} sm={12} xs={12} className="align-self-center text-center d-grid p-2">
					<Button variant="light" className="justify-content-center d-flex" onClick={() => {handleRemoveCard(card.id);}}>
						<span className="material-icons title-icon">delete</span>Remover
					</Button>
				</Col>
			</Row>
			{lastItem ? <Col md={12}>
				<hr/>
			</Col> : <></>}
		</>
	)
}
